import React from "react";
import LocationPage from "./LocationPage";

export default function WebdesignAgenturGraz() {
  return <LocationPage locationKey="graz" />;
}
